/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NumberCircle03Icon16Light } from './NumberCircle03Icon16Light';
import { NumberCircle03Icon16Regular } from './NumberCircle03Icon16Regular';
import { NumberCircle03Icon16Solid } from './NumberCircle03Icon16Solid';
import { NumberCircle03Icon20Light } from './NumberCircle03Icon20Light';
import { NumberCircle03Icon20Regular } from './NumberCircle03Icon20Regular';
import { NumberCircle03Icon20Solid } from './NumberCircle03Icon20Solid';
import { NumberCircle03Icon24Regular } from './NumberCircle03Icon24Regular';
import { NumberCircle03Icon24Solid } from './NumberCircle03Icon24Solid';
import { NumberCircle03Icon32Regular } from './NumberCircle03Icon32Regular';
import { NumberCircle03Icon64Regular } from './NumberCircle03Icon64Regular';
var sizes = {
    16: {
        light: NumberCircle03Icon16Light,
        regular: NumberCircle03Icon16Regular,
        solid: NumberCircle03Icon16Solid,
    },
    20: {
        light: NumberCircle03Icon20Light,
        regular: NumberCircle03Icon20Regular,
        solid: NumberCircle03Icon20Solid,
    },
    24: {
        regular: NumberCircle03Icon24Regular,
        solid: NumberCircle03Icon24Solid,
    },
    32: {
        regular: NumberCircle03Icon32Regular,
    },
    64: {
        regular: NumberCircle03Icon64Regular,
    },
};
export var NumberCircle03Icon = forwardRef('NumberCircle03Icon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
